import React, { useState, useEffect } from 'react';
import { DatePicker, TextField, FontIcon } from 'react-md';
import moment from "moment"
import "./SFDatePicker.css";

const SFDatePicker = ({
    id,
    disabled,
    label,
    value,
    placeholder,
    onDatePickerChange,
    onDateChange,
    showLabel,
}) => {

    const [dateText, setDateText] = useState("")
    const [error, setError] = useState("");
    const [showPicker, setShowPicker] = useState(false);

    useEffect(() => {
        setDateText(value ? moment(value).format("MM/DD/YYYY") : "")
    }, [value])

    const handleTextChange = (value) => {
        setDateText(value);
        if (!value) {
            setError("");
            return;
        }
        const isValid = moment(value, "MM/DD/YYYY", true).isValid();

        if (!isValid) {
            setError("Invalid date. Format is MM/DD/YYYY");
            return;
        } else {
            setError("");
        }
        onDateChange(value);
    };


    const togglePicker = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowPicker(!showPicker);
    };

    return (
        <div style={{ position: 'relative' }}
        className={`${showLabel ? "" : "hide-date-time-picker-label"}`}
        >
            <TextField
                disabled={disabled}
                id={`sf-date-picker-input-${id}`}
                style={{ position: "relative", width: "100%" }}
                label={showLabel ? label : null}
                placeholder={placeholder}
                value={dateText}
                onChange={handleTextChange}
                error={!!error}
                errorText={
                    <small style={{
                        position: 'absolute',
                        width:"200px"
                    }}>{error}</small>
                }
                leftIcon={
                    <FontIcon
                        onClick={togglePicker}
                        style={{ cursor: 'pointer' }}
                    >
                        event
                    </FontIcon>
                }
            />
            {showPicker && (
                <div style={{ position: 'absolute', zIndex: 1000, top: '100%' }}>
                    <DatePicker
                        disabled={disabled}
                        className='sf-date-picker'
                        id={`sf-date-picker-date-${id}`}
                        displayMode="portrait"
                        value={value}
                        onChange={onDatePickerChange}
                        visible={showPicker}
                        onVisibilityChange={setShowPicker}
                    />
                </div>
            )}
        </div>
    );
}

export default SFDatePicker;